var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m20.6629 17.5379c-.3661.3661-.9597.3661-1.3258 0l-4.3371-4.3371-4.3371 4.3371c-.3661.3661-.9597.3661-1.32581 0-.36612-.3661-.36612-.9597 0-1.3258l5.00001-5c.3661-.3661.9597-.3661 1.3258 0l5 5c.3661.3661.3661.9597 0 1.3258z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretUp);
export default __webpack_public_path__ + "static/media/icon_caret_up.61eb39a6816b859c0ea2b7a9bbf2bdb5.svg";
export { ForwardRef as ReactComponent };